import { render, staticRenderFns } from "./CollapseItem.vue?vue&type=template&id=30a8a93a&"
import script from "./CollapseItem.vue?vue&type=script&lang=js&"
export * from "./CollapseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports